import { useNavigate } from 'react-router-dom';

const buttonClass =
  'h-9 px-4 rounded-xl bg-primary text-white text-sm font-semibold hover:bg-primary-hover cursor-pointer';

export function WhatsAppListPrerequisite({ connection, children }) {
  const navigate = useNavigate();
  const openSetup = () => navigate('/integrations/whatsapp-business');

  if (connection.phase === 'checking') {
    return (
      <p className="py-6 text-center text-sm font-medium text-[#868686]">
        Checking connection…
      </p>
    );
  }

  if (connection.phase === 'error') {
    return (
      <div className="py-6 flex flex-col items-center gap-3 text-center">
        <p className="text-sm font-medium text-[#1F2241]">
          Could not check the WhatsApp connection. Try again.
        </p>
        <button
          type="button"
          onClick={() => connection.refetch()}
          className={buttonClass}
        >
          Retry
        </button>
      </div>
    );
  }

  if (connection.phase === 'disconnected') {
    return (
      <div className="py-6 flex flex-col items-center gap-3 text-center">
        <p className="text-sm font-medium text-[#1F2241]">
          Connect WhatsApp to get started
        </p>
        <button type="button" onClick={openSetup} className={buttonClass}>
          Connect WhatsApp
        </button>
      </div>
    );
  }

  if (connection.phase === 'pending') {
    return (
      <div className="py-6 flex flex-col items-center gap-3 text-center">
        <p className="text-sm font-medium text-[#1F2241]">
          WhatsApp connection is pending. Finish setup to load this list.
        </p>
        <button type="button" onClick={openSetup} className={buttonClass}>
          Check setup
        </button>
      </div>
    );
  }

  return children;
}

export function ListRequestError({ message, onRetry }) {
  return (
    <div className="py-6 flex flex-col items-center gap-3 text-center">
      <p className="text-sm font-medium text-[#1F2241]">{message}</p>
      <button
        type="button"
        onClick={onRetry}
        className="h-9 px-4 rounded-xl bg-primary text-white text-sm font-semibold hover:bg-primary-hover cursor-pointer"
      >
        Retry
      </button>
    </div>
  );
}
